import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { MASS_SONG_ROLES, MassRoleSelector } from '../../../../../constants/songRoles';

/**
 * Modal for editing a song's role in the setlist
 * 
 * @param {boolean} show - Whether to show the modal
 * @param {function} onHide - Function to call when hiding the modal
 * @param {string} songTitle - Title of the song being edited
 * @param {string} role - Current role value
 * @param {function} setRole - Function to update role value
 * @param {function} onSave - Function to call when saving the role
 * @param {string} eventType - Type of event (e.g., "mass" or other)
 * @returns {JSX.Element} Modal component
 */
const EditRoleModal = ({ 
  show, 
  onHide, 
  songTitle, 
  role, 
  setRole, 
  onSave,
  eventType
}) => {
  // Check if the event is a Mass
  const isMassEvent = eventType === "mass";

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="bg-dark text-white">
        <Modal.Title style={{ fontSize: '1.2rem' }}>
          Uredi vlogo pesmi
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-white">
        <Form.Group>
          <Form.Label>Pesem</Form.Label>
          <Form.Control
            type="text"
            value={songTitle}
            disabled
            className="mb-3 bg-secondary text-white"
          />
          
          <Form.Label>Vloga pesmi</Form.Label>
          
          {isMassEvent ? (
            <MassRoleSelector
              value={role || ''}
              onChange={(e) => setRole(e.target.value)}
              className="bg-secondary text-white"
            />
          ) : (
            <Form.Control
              type="text"
              value={role || ''}
              onChange={(e) => setRole(e.target.value)}
              placeholder="Vstopna, Psalm, Povzdig, Obhajilo, itd."
              className="bg-secondary text-white"
            />
          )}
          
          <Form.Text className="text-muted">
            {isMassEvent ? 'Izberite vlogo pesmi za mašo.' : 'Vnesite vlogo pesmi, npr. Vstopna, Psalm, Aleluia, itd.'}
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-white justify-content-center">
        <Button 
          variant="secondary" 
          onClick={onHide}
          size="sm"
          style={{ width: '100px' }}
        >
          Prekliči
        </Button>
        <Button 
          variant="primary" 
          onClick={onSave}
          size="sm"
          style={{ width: '100px' }}
        >
          Shrani
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditRoleModal;